export default __webpack_public_path__ + "static/media/bg7.06bc858a.jpg";